import React from 'react';

import Dim from 'web/components/common/modal/common/Dim';
import * as input from 'web/components/common/modal/common/input';
import Logo from 'web/components/common/modal/common/Logo';
import CloseBtn from 'web/components/common/modal/common/CloseBtn';

import classNames from 'classnames/bind';
import styles from './FindPassword.scss';
const cx = classNames.bind(styles);

const FindPassword = ({
  phone = '',
  error = '',
  handleChange,
  handleSubmit,
  handlePopup,
}) => {
  return (
    <Dim onClick={handlePopup.close}>
      <div
        className={cx('FindPassword')}
        onClick={e => e.stopPropagation()}
        onMouseDown={e => e.stopPropagation()}
      >
        <Logo title={'비밀번호 찾기'} />
        <form
          onSubmit={e => {
            e.preventDefault();
            handleSubmit(e);
          }}
        >
          <input.Text
            key={`join-username`}
            type={'text'}
            name={'phone'}
            value={phone}
            error={error}
            onChange={handleChange}
            placeholder={`휴대전화번호를 입력해주세요.`}
          />

          <div className="buttons">
            <input.Button type="submit" onClick={handleSubmit}>
              이메일 찾기
            </input.Button>
          </div>
        </form>

        <div className="links">
          <button type="button" onClick={handlePopup.findEmail}>
            이메일을 잊어버리셨나요?
          </button>
        </div>

        <input.BottomButton msg={``} onClick={() => handlePopup.login()}>
          로그인하러 가기
        </input.BottomButton>

        <CloseBtn onClick={handlePopup.close} className={['btn-close']} />
      </div>
    </Dim>
  );
};

export default FindPassword;
